import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, RedirectCommand, ResolveFn, Router } from '@angular/router';
import { NotificationService } from '@rms/core/notification';
import { AppError } from '@rms/sdk/errors';
import { catchError, Observable, of, tap } from 'rxjs';

import { Partner, PARTNER_ID_PARAMETER } from '../models';
import { PartnerService } from '../services';
import { PartnerStoreService } from '../store';

export const partnerResolver: ResolveFn<Partner | RedirectCommand> = (
  route: ActivatedRouteSnapshot
): Observable<Partner | RedirectCommand> | RedirectCommand => {
  const router = inject(Router);
  const notification = inject(NotificationService);
  const store = inject(PartnerStoreService);
  const partnersList = new RedirectCommand(router.parseUrl('/partners'));
  const partnerId = route.paramMap.get(PARTNER_ID_PARAMETER);

  if (!partnerId) {
    return partnersList;
  }

  return inject(PartnerService)
    .getPartner(partnerId)
    .pipe(
      tap((partner) => store.setPartner(partner)),
      catchError((error: AppError) => {
        notification.error(error.message);

        return of(partnersList);
      })
    );
};
